import React, { useEffect, useState } from "react";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { useDispatch } from "react-redux";
import { success_retrieve_module_information } from "../../../../reducers/auth_tenant/retrieve_module_information_Slice";

const User = ({ user_info, tenant_info }) => {

  // Parse profiles safely
  const profiles = JSON.parse(localStorage.getItem("user_account")) || [];
  const module_name = JSON.parse(localStorage.getItem("module_name")) || "";
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  const [user_information, setUserInformation] = useState(user_info);

  useEffect(() => {
    setUserInformation(user_info);
  }, [user_info]);

  const handleSignout = () => {
    localStorage.removeItem("profile_access");
    localStorage.removeItem("user_account");
  };

  const handleSwitchProfile = (profile) => {
    dispatch(success_retrieve_module_information({ module_name: profile?.module_name }));
    localStorage.setItem("module_name", JSON.stringify(profile?.module_name));
    window.location.reload();
  };

  const filtered_profiles = (prof_data) => {
    const data = prof_data?.filter(
      (prof) => prof?.module_name !== module_name
    );
    return data;
  };

  // UI ONLY: module icons (NioIcons with safe fallback)
  const moduleIcon = (module) => {
    switch (module)
    {
      case "inventory":
        return "package-fill";      // warehouse / stock
      case "promotions":
        return "gift";      // fallback if megaphone not available
      default:
        return "layers-fill";
    }
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => ev.preventDefault()}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-md-block">
            <div className="user-status">
              {user_information?.position}
            </div>
            <div className="user-name dropdown-indicator">
              {user_information?.first_name
                ? `${user_information.first_name} ${user_information.last_name}`
                : user_information?.name}
            </div>
          </div>
        </div>
      </DropdownToggle>

      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">

        {/* User Card */}
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <UserAvatar icon="user-alt" className="sm" />
            </div>
            <div className="user-info">
              <span className="lead-text">
                {user_information?.first_name
                  ? `${user_information.first_name} ${user_information.last_name}`
                  : user_information?.name}
              </span>
              <span className="sub-text">{user_information?.department}</span>
              <span className="sub-text">{user_information?.position}</span>
            </div>
          </div>
        </div>

        {/* SWITCH PROFILE (ONLY IF MORE THAN ONE) */}
        {profiles?.length > 1 && (
          <div className="dropdown-inner">
            <div className="dropdown-head">
              <span className="sub-title">Switch Module</span>
            </div>
            <LinkList>
              {filtered_profiles(profiles)?.map((profile, index) => (
                <LinkItem
                  key={index}
                  href={profile?.module_name}
                  icon={moduleIcon(profile?.module_name)}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSwitchProfile(profile);
                  }}
                >
                  {profile?.module_name
                    ?.replace(/_/g, " ")
                    .toUpperCase() || "--"}
                </LinkItem>
              ))}
            </LinkList>
          </div>
        )}

        {/* Sign Out */}
        <div className="dropdown-inner">
          <LinkList>
            <a
              href={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/auth`}
              onClick={handleSignout}
              className="link-item"
            >
              <Icon name="signout" />
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>

      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
